<template>
  <simple-modal
    :open.sync="open"
    title="Offene Rechnungen"
    content-css="width: 1000px; max-width: 95vw"
  >
    <template #body>
      <open-invoices-table />
    </template>

    <template #actions>
      <q-btn
        class="no-shadow"
        label="Schließen"
        @click="hide"
      />
    </template>
  </simple-modal>
</template>

<script>
import SimpleModal from '@/components/base/SimpleModal.vue';
import OpenInvoicesTable from '@/components/payment/OpenInvoicesTable.vue';
import { vModel, modal } from '@/plugins/mixins';

export default {
  name: 'OpenInvoicesModal',
  components: {
    SimpleModal,
    OpenInvoicesTable,
  },
  mixins: [
    vModel('open'),
    modal,
  ],
};
</script>
